import * as assert from 'assert';
import { computed, observable } from 'mobx';
import { IPublicUser, IUpdateUser } from '../_interfaces/IUser';
import { UserService } from '../_services/UserService';
import * as images from '../images/images';
import { AStoreWithMappedData } from './AStoreWithMappedData';
import { AuthorizationStore } from './AuthorizationStore';

export const DEFAULT_USER_PROFILE: IPublicUser = {
    id: -1,
    first_name: 'A User',
    last_name: '',
    profile_image_url: images.NoProfileImageUrl
};

export class UserStore extends AStoreWithMappedData<IPublicUser> {
    private _userService: UserService;
    @observable
    private _authorizationStore: AuthorizationStore;

    public constructor(authToken: string, authStore: AuthorizationStore) {
        super();
        this._authorizationStore = authStore;
        this._userService = new UserService(authToken);
        this.loadData();
    }

    @computed
    public get userName(): string {
        if (this._authorizationStore === undefined || !this._authorizationStore.authIsResolved || !this._authorizationStore.isAuthenticated) {
            return '';
        }

        const user = this.currentUser;

        if (user === undefined) {
            return '';
        }

        return `${user.first_name} ${user.last_name.substring(0, 1).toUpperCase()}.`;
    }

    @computed
    public get currentUser(): IPublicUser {
        if (!this._authorizationStore.authIsResolved || !this._authorizationStore.isAuthenticated) {
            return DEFAULT_USER_PROFILE;
        }

        return this.recordsMap.get(this._authorizationStore.user.id) || this._authorizationStore.user;
    }

    @computed
    public get usersMap(): Map<number, IPublicUser> {
        return this.recordsMap;
    }

    public static getPublicUserFullName(user: IPublicUser): string {
        return `${user.first_name} ${user.last_name}`;
    }

    public updateCurrentUserInfo(args: IUpdateUser): Promise<void> {
        return this._userService.update(args).then(() => {
            return this.loadData();
        });
    }

    public getUserInitials(): string {
        return this.currentUser.first_name[0] + this.currentUser.last_name[0];
    }

    public getUserFullName(): string {
        return this.currentUser.first_name + ' ' + this.currentUser.last_name;
    }
    public getUsers(ids: Array<number>): Array<IPublicUser> {
        console.assert(ids, 'Paramater is undefined');

        const out: Array<IPublicUser> = [];

        ids.forEach(id => {
            const user: IPublicUser | undefined = this.usersMap.get(id);
            if (user) {
                out.push(user);
            } else {
                assert(false, 'getUsers passed unavailable user ID');
            }
        });

        return out;
    }

    protected loadData(): Promise<void> {
        return this._userService.getAll().then((users: Array<IPublicUser>) => {
            const allUsers = [...users];

            if (!allUsers.some(user => user.id === this._authorizationStore.user.id)) {
                allUsers.push(this._authorizationStore.user);
            }

            this.addRecordsToMap(allUsers);
        });
    }
}



// WEBPACK FOOTER //
// ./src/_stores/UserStore.ts